module.exports = __webpack_public_path__ + "img/icon_enhance.b55c4ec6.svg";